import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { AppRoutePath } from 'src/app/globals/app-routepath';

export const passwordResetGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const authService = inject(AuthService);

  // Check whether the user is required to reset the password
  const passwordResetRequired =
    authService.isPasswordResetRequired();

   // No reset required → allow navigation
  if (!passwordResetRequired) {
    return true;
  }

  // Already on reset password page → allow
  if (state.url === AppRoutePath.USER.RESET_PASSWORD) {
    return true;
  }

  // Force user to reset password
  return router.createUrlTree([
    AppRoutePath.USER.RESET_PASSWORD
  ]);
};
